"use strict";

AquaTechTheme.registerModule('country-select', null, function() {
  AquaTechTheme.CountrySelect = {
    $: null,
    DEBUG: false,
    cookieName: 'preferredStore26b',

    onDocReady: function() {
      this.$ = AquaTechTheme.$;
      var $ = this.$;

      this.initCountrySelect();
      this.initCountrySelectControls();
    },

    initCountrySelect: function() {
      var $ = this.$;

      $("#country-toggle, #country-toggle-mb, .grid .large--one-quarter:nth-child(3) .footer-header").click(function(e) {
        e.preventDefault();
        $("#overlay, #country_list_menu").fadeIn('fast');
      });

      $("#country_list_menu_close_link > a").click(function(e) {
        e.preventDefault();
        $("#country_list_menu").hide();
        $("#overlay").hide();
      });

      $(document).on("mousedown touchstart", function(e) {
        var $countryPopup = $("#country_list_menu");
        if ($countryPopup.is(':visible')) {
          if (!$countryPopup.is(e.target) && $countryPopup.has(e.target).length === 0) {
            $countryPopup.hide();
          }
        }
      });

      // Try Geolocate immediately. On fail try again after 3sec.
      if (window.easylocation && window.easylocation.locationData) {
          AquaTechTheme.CountrySelect.attemptGeolocate();
      } else {
        setTimeout(function() {
          if (!window.easylocation || !window.easylocation.locationData) {
            console.log('no window.easylocation.locationData after 3 secs.');
            return;
          }
          AquaTechTheme.CountrySelect.attemptGeolocate();
        }, 3000);
      }
    },

    attemptGeolocate: function() {
      var $ = this.$;

      var AUTO_REDIRECT = true;

      // Geolocate...
      var storeDomain = window.location.hostname;
      var domainPrefix = 'https://' + storeDomain;
      var urlPath = window.location.pathname;
      var $geolocateNotice = $(".geolocate-notice");
      var suggest = '';

      var storeNames = {
        'aquatech.net'    : 'US',
        'au.aquatech.net' : 'AU',
        'eu.aquatech.net' : 'EU'
      };

      var storeURLs = {
        'US' : 'https://aquatech.net',
        'AU' : 'https://au.aquatech.net',
        'EU' : 'https://eu.aquatech.net'
      };

      // Store explicitly picked?
      if (AquaTechTheme.getUrlParameter('countrySelect')) {
        var thisStore = storeNames[storeDomain];
        Cookies.set(AquaTechTheme.CountrySelect.cookieName, thisStore, { domain: 'aquatech.net', expires: 3650 });
        console.log(AquaTechTheme.CountrySelect.cookieName + ': ' + thisStore);
      };

      var countryCode = window.easylocation.locationData.country.iso_code;
      if (!countryCode) { return; }

      var currentStore = storeNames[storeDomain];
      if (!currentStore) { return; }

      var suggestStore = null;

      var storeMapping = AquaTechTheme.COUNTRY_TO_STORE[countryCode];
      if (storeMapping) {
        if (currentStore !== storeMapping.suggest) {
          // Not in recommended store for this country, suggest it.
          suggestStore = storeMapping.suggest;
        }
      } else {
        // Unrecognised country, suggest default.
        suggestStore = 'AU';
      }

      console.log('Loc: ' + countryCode + ', Store: ' + currentStore +  ', Suggest: ' + suggestStore);

      var urlParts = AquaTechTheme.getUrlParts();
      if (suggestStore) {
        var suggestUrl = storeURLs[suggestStore] + urlParts.path + (urlParts.args ? '?' + urlParts.args : '');
        suggestUrl = AquaTechTheme.removeParam('countrySelect', suggestUrl);
        suggestUrl = AquaTechTheme.applyParam('countrySelect', 1, suggestUrl);
        var suggestLink = '<a class="button" href="' + suggestUrl + '">' + suggestStore + ' Store</a>';
        var storePrompt = 'Viewing our ' + storeNames[storeDomain] + ' Store from another country? Switch to our ' + suggestLink;
        $geolocateNotice.html(storePrompt);
        $geolocateNotice.fadeIn('slow');
      }

      // Detect 'Preview' mode.
      var isPreview = $('#OnlineStorePreviewBarNextData').length == 1;
      if (isPreview) {
        console.log('is preview mode');
      }

      // Redirection:

      var preferredStore = Cookies.get(AquaTechTheme.CountrySelect.cookieName);

      var shouldRedirect = false;
      var gotoStore = suggestStore;

      if (preferredStore) {
        console.log('Preferred: ' + preferredStore);
        if (currentStore !== preferredStore) {
          gotoStore = preferredStore;
          shouldRedirect = true;
        }
      } else if (suggestStore && currentStore !== suggestStore) {
        shouldRedirect = true;
      }

      if (preferredStore == 'EU') { /* Stop EU redirect */
        preferredStore = null;
        shouldRedirect = false;
      }

      if (shouldRedirect) {
        var redirectUrl = storeURLs[gotoStore] + urlParts.path + (urlParts.args ? '?' + urlParts.args : '');
        redirectUrl = AquaTechTheme.removeParam('countrySelect', redirectUrl);
        console.log('Redirect: ' + redirectUrl);

        if (isPreview) {
          console.log('is preview mode. No redirect.');
        } else if (AquaTechTheme.isCrawlerBot()) {
          console.log('is crawler. No redirect.');
        } else if (AUTO_REDIRECT) {
          window.location.replace(redirectUrl);
        } else {
          console.log('Redirection disabled.');
        }
      }
    },

    initCountrySelectControls: function() {
      var $ = this.$;

      var path = window.location.pathname;
      var $links = $('#country_list_menu .option a');
      $links.each(function() {
        var $link = $(this);
        var url = $link.attr('href');
        var split = url.split('?');
        var newLink = split[0] + path.slice(1);
        if (split.length == 2) {
          newLink += '?' + split[1];
        }
        $link.attr('href', newLink);
      });

      var $euSelect = $('#country_list_menu .country-select');
      $euSelect.on('change', function() {
        var selected = $(this).find(":selected").val();
        if (selected !== '') {
          window.location.href = selected;
        }
      });
    }
  };

  AquaTechTheme.$(function() { AquaTechTheme.CountrySelect.onDocReady(); });
});
